import { Base } from '@studiometa/js-toolkit';

/**
 * Function randomItem
 * @param {any[]} array
 * @returns {any}
 */
function randomItem(array) {
  return array[Math.floor(Math.random() * array.length)];
}

/**
 * Function randomItemWithWeight
 * @param {[any, number][]} items
 * @returns {any}
 */
function randomItemWithWeight(items) {
  return randomItem(
    items.flatMap(([value, weight]) => {
      return new Array(weight * 100).fill(value);
    }),
  );
}

/**
 *
 */
export default class DownloadLink extends Base {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'DownloadLink',
    emits: ['set-url'],
    options: {
      abDisabled: {
        type: Boolean,
        default: true,
      },
    },
  };

  /**
   * Datalayer
   * @returns {string}
   */
  get dataLayer() {
    return this.datalayerNames?.[this.ABTesting] ?? 'store';
  }

  /**
   * mounted
   */
  mounted() {
    if (!this.$options.abDisabled) {
      this.originalUrl = new URL(this.$el.href);
      this.links = [`https://web.may-care.fr/intro`, this.originalUrl.href];
      this.datalayerNames = ['funnel', 'store'];

      // funnel - 20% / store - 80%
      this.ABTesting = randomItemWithWeight([
        [0, 0.2],
        [1, 0.8],
      ]);

      let chainValue = '?';

      if (this.links[this.ABTesting].includes('?')) {
        chainValue = '&';
      }

      this.$el.href = `${this.links[this.ABTesting]}${chainValue}ab_id=${this.dataLayer}`;

      if (this.ABTesting === 0) {
        this.$el.querySelector('span').textContent = 'Essayer May';
      }
    }

    this.$emit('set-url', this.$el.href);

    this.sendDatalayer();
  }

  /**
   * Check link before redirect
   * @param  {object} e current element.
   * @returns {void}
   */
  onClick(e) {
    if (this.$el.href.includes('web.may-care.fr') && this.$parent.mixpanelDistinctID) {
      e.preventDefault();
      window.location.href = `${this.$el.href}&distinct_id=${this.$parent.mixpanelDistinctID}`;
    }
  }

  /**
   * Send Datalayer pageView Event
   */
  sendDatalayer() {
    if (window['datalayer-article']) {
      window.dataLayer = window.dataLayer || [];
      /* eslint-disable camelcase */
      window['datalayer-article'].AB_test_variation_id = this.dataLayer;
      window.dataLayer.push(window['datalayer-article']);
    }
  }
}
